/**
 * Mode-aware wrapper for tutors route.
 * Dispatches to in-person or remote page based on {@link useMode}.
 */

import { useMode } from '@/contexts/ModeContext';
import { TutorsManagementPage as TutorsInPersonManagementPage } from '@/components/pages/management-pages/inperson/TutorsManagementPage';
import { TutorsManagementPage as TutorsRemoteManagementPage } from '@/components/pages/management-pages/remote/TutorsManagementPage';

/** Mode-aware wrapper that mounts in-person or remote tutors. */
export function TutorsRouteDispatcher() {
  const { mode } = useMode();

  if (mode === 'remote') {
    return <TutorsRemoteManagementPage />;
  }

  return <TutorsInPersonManagementPage />;
}
